import type { ComponentType } from 'react';
import { GuessSongDemo } from './GuessSongDemo';
import { GuessWordDemo } from './GuessWordDemo';
import { MemoryMatchDemo } from './MemoryMatchDemo';
import { PuzzleDemo } from './PuzzleDemo';
import { RelatedWordsDemo } from './RelatedWordsDemo';
import { SlotMachineDemo } from './SlotMachineDemo';
import type { DemoChallenge } from './types';

export type DemoComponent = ComponentType<{ challenge: DemoChallenge }>;

/** Minigame challenge types keyed by `challenge.type`. */
const BY_TYPE: Record<string, DemoComponent> = {
  memory_match: MemoryMatchDemo,
  slot_machine: SlotMachineDemo,
  guess_word: GuessWordDemo,
  guess_song: GuessSongDemo,
  related_words: RelatedWordsDemo,
  puzzle: PuzzleDemo,
};

/**
 * Resolve the demo component for a challenge, or `undefined` when the type has
 * no interactive preview. Puzzle is matched on either `type` or `answerType`
 * (the importer sets both, but the answer type is the more reliable signal).
 */
export function getDemoComponent(challenge: DemoChallenge): DemoComponent | undefined {
  if (challenge.answerType === 'puzzle') return PuzzleDemo;
  return BY_TYPE[challenge.type];
}
